exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/*Styling for information icon and hovering of icon*/\r\n.fa-info-circle {\r\n    background-color: transparent;\r\n    color: grey;\r\n    font-style: italic;\r\n    font-size: 13px;\r\n}\r\nem:hover {\r\n    color: #12408B;\r\n}\r\n.remove-padd {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n/*End of styling for information icon and hovering of icon*/\r\n\r\n/*overriding default styling of tooltip*/\r\n::ng-deep .ui-tooltip-top .ui-tooltip-arrow  {\r\n    left: 12.5%;\r\n}\r\n    \r\n::ng-deep .ui-tooltip.ui-tooltip-top {\r\n    margin-left: 30px;;\r\n}\r\n\r\n::ng-deep .ui-tooltip .ui-tooltip-text {\r\n    background-color: #12408B;\r\n    color: white;\r\n}\r\n/* End of overriding default styling of tooltip*/\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/tooltip/tooltip.component.css
// module id = ../../../../../src/app/shared/components/tooltip/tooltip.component.css
// module chunks = main